import styled, { css } from "styled-components";
import { getCSSExternalSpace } from "../../../utils/css";

export const TextLink = styled.a`
  display: block;
  ${({ theme, margin }) => css`
    color: ${theme.colors.darkGray2};
    font-size: 16px;
    font-weight: 600;
    text-decoration: underline;
    text-decoration-color: ${theme.colors.darkGray2};
    margin: ${getCSSExternalSpace(margin)};

    &:hover {
      color: ${theme.colors.prune};
      text-decoration: underline;
    }
  `};
`;

export const Container = styled.div`
  background-repeat: no-repeat;
  background-position: top right;
  min-height: 520px;
  padding-top: 2em;
  ${({ background }) => css`
    background-image: url(${background.src});
  `}

  @media only screen and (max-width: 768px) {
    background: none;
    min-height: unset;
    padding-top: 1.5em;
  }
`;

export const Content = styled.div`
  padding: 20px 0px 100px 150px;
  max-width: 650px;
  ${({ minHeight }) => css`
    min-height: ${minHeight || "auto"};
  `}

  @media only screen and (max-width: 768px) {
    padding: 0px 20px;
    min-height: auto !important;
  }
`;
